import React from 'react';
import { Link } from 'react-router-dom';
import { Seo, ContentGuidesStrip } from '../shared';
import ExploreHero from '../explore/ExploreHero';
import InternationalCardBanner from './InternationalCardBanner';
import ExperienceCard from './ExperienceCard';
import { HOME_EXPERIENCE_CARDS, TRAVEL_SERVICES_INTRO } from '../../data/bookingExperienceData';
import { BOOKING_EDITORIAL_SECTIONS } from '../../data/bookingEditorialContent';
import { EXPLORE_IMAGES } from '../../data/exploreImages';
import '../../styles/booking-experience.scss';
import '../../styles/explore.scss';

function TravelServicesPage() {
	return (
		<div className="explore-page travel-services-page">
			<Seo
				title="Book a Trip — Group Departures, Private Tours & Shared Rides"
				path="/book-experiences"
				description="Book Nepal group treks, homestays, private tours, shared rides & domestic flights with your Visa or Mastercard. Secure checkout in USD or NPR through VisitAllNepal."
			/>
			<ExploreHero
				image={EXPLORE_IMAGES.trekking}
				eyebrow="Book a trip"
				title={TRAVEL_SERVICES_INTRO.title}
				lead={TRAVEL_SERVICES_INTRO.lead}
				compact
				booking
			/>
			<div className="explore-body container travel-services-page__body">
				<div className="travel-services-page__cards-panel">
					<div className="travel-services-page__intl-banner">
						<InternationalCardBanner layout="inline" showScopes showLocalWallets={false} />
					</div>
					<div className="travel-services-page__booking-header">
						<h2 className="travel-services-page__booking-title">Pick how you want to travel</h2>
						<p className="travel-services-page__intro">
							Domestic flights, fixed-date group treks, private homestay &amp; culture tours, or shared
							intercity rides — same secure card checkout for overseas travelers.
						</p>
					</div>
					<div className="home-experience-band__grid travel-services-page__grid">
						{HOME_EXPERIENCE_CARDS.map((card) => (
							<ExperienceCard key={card.id} card={card} titleTag="h3" />
						))}
					</div>
				</div>
				<section className="travel-services-page__editorial" aria-label="How booking works">
					{BOOKING_EDITORIAL_SECTIONS.map((section) => (
						<article key={section.id} className="travel-services-page__editorial-block">
							<h2 className="travel-services-page__editorial-title">{section.title}</h2>
							{section.paragraphs.map((p) => (
								<p key={p.slice(0, 40)} className="travel-services-page__editorial-text">{p}</p>
							))}
							{section.links && section.links.length > 0 && (
								<div className="travel-services-page__editorial-links">
									{section.links.map((link) => (
										<Link key={link.to} to={link.to} className="travel-services-page__editorial-link">
											{link.label} →
										</Link>
									))}
								</div>
							)}
						</article>
					))}
				</section>

				<ContentGuidesStrip compact />
			</div>
		</div>
	);
}

export default TravelServicesPage;
